/* Liberté B2C filter cleanup – final */
(function () {
  var kids = ['86/92','98/104','110/116','122/128','134/140','146/152'];
  var junkProducts = [
    'ALMA NYHEDER','ALMA KJOLER','NYHEDER','HENNY & NATALIA','ALMA BASICS','BØRN UDSALG'
  ];

  function norm(v) {
    return String(v || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s*\(\d+\)\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isBlockedSize(v) {
    v = norm(v);
    return kids.indexOf(v) !== -1 || /^Assortment\s+[A-Z]\d+$/i.test(v) || /^[AB]\d+$/i.test(v);
  }

  function isBlockedProduct(v) {
    v = norm(v).toUpperCase();
    return junkProducts.indexOf(v) !== -1;
  }

  function removeChoice(el) {
    if (!el || !el.closest) return;
    var row = el.closest('li, label, .Linklist__Item, .HorizontalList__Item, .Facet__Value, .CollectionFilters__Item');
    if (!row) {
      var p = el.parentElement;
      while (p && p !== document.body) {
        if (p.querySelector && (p.querySelector('input[type="checkbox"]') || p.matches('[data-tag]'))) { row = p; break; }
        p = p.parentElement;
      }
    }
    (row || el).remove();
  }

  function cleanFilterChoices(root) {
    if (!root || !root.querySelectorAll) return;

    /* Theme's tag based collection filters */
    root.querySelectorAll('[data-tag]').forEach(function (el) {
      var tag = String(el.getAttribute('data-tag') || '').toLowerCase();
      var label = norm(el.textContent || el.getAttribute('data-tooltip') || '');
      if (tag.indexOf('size-') === 0 && isBlockedSize(label)) removeChoice(el);
      if (tag.indexOf('produkter-') === 0 && isBlockedProduct(label)) removeChoice(el);
    });

    /* Custom checkbox dropdowns used on the collection page */
    root.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      var row = input.closest('label, li, div');
      if (!row) return;
      var label = norm(row.textContent);
      if (isBlockedSize(label) || isBlockedProduct(label)) removeChoice(input);
    });

    /* Product page size selectors / fallbacks */
    root.querySelectorAll('.SizeSwatchList--size .SizeSwatch__Radio, .OptionSelector .Popover__Value[data-value], select[name="id"] option').forEach(function (el) {
      var v = (el.getAttribute && el.getAttribute('data-value')) || el.value || el.textContent || '';
      if (isBlockedSize(v)) removeChoice(el);
    });
  }

  function run() { cleanFilterChoices(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('click', function () {
    setTimeout(run, 0);
    setTimeout(run, 100);
  }, true);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1 || n.nodeType === 11) cleanFilterChoices(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();